
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"lotDetailInfoForDeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lotDetailInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"article"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pk"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"floor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plan"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"planWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"planHeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"planHover"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plan"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"plan_hover"},"name":{"kind":"Name","value":"planHover"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"plan_png"},"name":{"kind":"Name","value":"planPng"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"section"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalFloors"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"building"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"builtYear"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"readyQuarter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalFloor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"windowViewPlanLotPreview"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"windowViewPlanLotDisplay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameDisplay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"miniPlan"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"miniPlanWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"miniPlanHeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"windowViewPlanDisplay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"windowViewPlanPreview"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compassAzimuth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compassStreetTop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compassStreetLeft"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compassStreetRight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compassStreetBottom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sunAzimuth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"planHover"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bookingActive"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"windowView"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ppoi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"windowviewangleSet"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"angle"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":948}};
    doc.loc.source = {"body":"query lotDetailInfoForDeal($id: ID!) {\n  lotDetailInfo(id: $id) {\n    #    type // с бэка ЛК\n    area\n    article\n    pk\n    floor {\n      id\n      number\n      plan\n      planWidth\n      planHeight\n      planHover\n    }\n    id\n    number\n    plan\n    plan_hover: planHover\n    plan_png: planPng\n    rooms\n    section {\n      id\n      name\n      number\n      totalFloors\n    }\n    \n    building {\n      address\n      builtYear\n      name\n      readyQuarter\n      totalFloor\n      windowViewPlanLotPreview\n      windowViewPlanLotDisplay\n\n      nameDisplay\n      miniPlan\n      miniPlanWidth\n      miniPlanHeight\n      windowViewPlanDisplay\n      windowViewPlanPreview\n      compassAzimuth\n      compassStreetTop\n      compassStreetLeft\n      compassStreetRight\n      compassStreetBottom\n      sunAzimuth\n      planHover\n      bookingActive\n\n    }\n\n    #window\n    windowView {\n      ppoi\n      windowviewangleSet {\n        angle\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["lotDetailInfoForDeal"] = oneQuery(doc, "lotDetailInfoForDeal");
        
